var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlcool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "29px",
    viewBox: "0 0 16 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alcool") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Client",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu---cat\\xE9gorie",
    transform: "translate(-263.000000, -489.000000)",
    fill: "#F46524",
    fillRule: "nonzero",
    stroke: "#F46524",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(195.000000, 453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alcool",
    transform: "translate(68.400000, 37.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03076096,23.9363751 L8.03076096,14.7811107 C11.8752095,14.4882964 14.9142857,11.2960179 14.9142857,7.40425346 C14.9142857,5.79444275 14.0480909,3.12055698 13.4148066,1.16778566 L13.1669998,0.398767801 C13.091281,0.16176077 12.8710082,0 12.6197595,0 L2.37938713,0 C2.1407762,0 1.92620383,0.146967857 1.8424722,0.368007087 C1.28834846,1.8263106 0,5.42873203 0,7.40537494 C0,11.2960179 3.03907618,14.4894713 6.88352476,14.7822321 L6.88352476,23.9375499 C4.00508208,24.0537571 1.1472362,25.0392214 1.1472362,26.7743714 C1.1472362,27.0876927 1.40423905,27.3428571 1.72088119,27.3428571 L13.1934045,27.3428571 C13.5100467,27.3428571 13.7670495,27.0876393 13.7670495,26.7731965 C13.7669957,25.0380999 10.9080743,24.0525822 8.03076096,23.9363751 Z M1.17589963,7.9749822 C1.15869082,7.78700006 1.1472362,7.59789643 1.1472362,7.40532154 C1.1472362,6.02221088 1.96524632,3.33011434 2.77750224,1.13926791 L12.2010476,1.13926791 L12.3226386,1.51865006 C12.897413,3.29251791 13.7670495,5.97441429 13.7670495,7.40532154 C13.7670495,7.59784302 13.7555949,7.78700006 13.7383861,7.9749822 L1.17589963,7.9749822 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcool);
export default __webpack_public_path__ + "static/media/alcool.0131be57d0f4915910dc08386a5641c2.svg";
export { ForwardRef as ReactComponent };